// extracted by css-extract-rspack-plugin
module.exports =  {"item":"Item-cH8P__item"};